import { render, staticRenderFns } from "./litelist2.vue?vue&type=template&id=3c0d87cc&scoped=true"
import script from "./litelist2.vue?vue&type=script&lang=js"
export * from "./litelist2.vue?vue&type=script&lang=js"
import style0 from "./litelist2.vue?vue&type=style&index=0&id=3c0d87cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0d87cc",
  null
  
)

export default component.exports